import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { chartColors } from "../../../Shared/colors";
import { useGetDashboardCompleteQuery } from "../../../features/employeeSlice";
import { 
  ClassificationContainer, 
  CustomPieTooltip, 
  ChartSkeleton,
  ClassificationLegend 
} from "../../../Shared/ChartComponents";

export const Classification = ({staff}) => {
  const { data: dashboardData, isFetching } = useGetDashboardCompleteQuery({staffId: staff?.id});

  if (isFetching) {
    return <ChartSkeleton />;
  }

  // Get the classification data
  const classificationData = dashboardData?.leadClassificationReport || [];
  
  const totalLeads = classificationData.reduce((sum, item) => sum + (item.count || 0), 0);

  // Add total to each data point for percentage calculation
  const dataWithTotal = classificationData.map(item => ({
    ...item,
    total: totalLeads
  }));


  // If no data, show empty state with debug info
  if (!dataWithTotal || dataWithTotal.length === 0 || totalLeads === 0) {
    return (
      <ClassificationContainer>
        <div className="chart-header">
          <div>
            <h3 className="chart-title">Lead Classification</h3>
            <p className="chart-subtitle">No classification data available</p>
          </div>
        </div>
        
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '250px',
          color: '#666',
          fontSize: '14px',
          gap: '10px'
        }}>
          <div>No lead classification data found for the selected staff member</div>
        </div>
      </ClassificationContainer>
    );
  }

  return (
    <ClassificationContainer>
      <div className="chart-header">
        <div>
          <h3 className="chart-title">Lead Classification</h3>
          <p className="chart-subtitle">Total leads: {totalLeads}</p>
        </div>
      </div>
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', minHeight: '250px' }}>
        <div style={{ flex: 1, height: '250px' }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={dataWithTotal}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                paddingAngle={2}
                dataKey="count"
              >
                {dataWithTotal?.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={chartColors.leadClassification[entry._id]} 
                  />
                ))}
              </Pie>
              <Tooltip content={<CustomPieTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        
        <div style={{ flex: 1 }}>
          <ClassificationLegend data={dashboardData?.leadClassificationReport} />
        </div>
      </div>
    </ClassificationContainer>
  );
};

